export default "__VITE_ASSET__N5LUaapU__"